import { ValidationPattern } from './regx';

const validData = ({ field, value }) => {
  const regexPattern = ValidationPattern[field];
  return new RegExp(regexPattern).test(value) ? true : false;
};

const required = ({ value, error }, customMEssage) => {
  if (!value) error = [...error, customMEssage ?? 'form.required'];

  return { value, error };
};
const optional = ({ value, error }, customMEssage) => {
  return { value, error: value ? error : [] };
};

const persianName = (value, customMEssage) => {
  const result = validData({ field: 'persianName', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const englishName = (value, customMEssage) => {
  const result = validData({ field: 'englishName', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const number = (value, customMEssage) => {
  const result = validData({ field: 'number', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];
  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const userName = (value, customMEssage) => {
  const result = validData({ field: 'userName', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const password = (value, customMEssage) => {
  const result = validData({ field: 'password', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const email = (value, customMEssage) => {
  const result = validData({ field: 'email', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const phone = (value, customMEssage) => {
  const result = validData({ field: 'phone', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const code = (value, customMEssage) => {
  const result = validData({ field: 'code', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const url = (value, customMEssage) => {
  const result = validData({ field: 'url', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};
const age = (value, customMEssage) => {
  const result = validData({ field: 'age', value });
  let error = [];
  if (!result) error = [customMEssage ?? 'form.invalid'];

  return {
    value,
    error,
    required: (message) => required({ value, error }, message),
    optional: (message) => optional({ value, error }, message),
  };
};

// const validation = {
//   persianName,
//   englishName,
//   number,
//   userName,
//   password,
//   email,
//   phone,
//   phone,
//   code,
//   url,
//   age,
// };

const validateForm = (schema = {}) => {
  let key = Object.keys(schema).find((item) => schema?.[item].length > 0);
  if (!key) return { result: true, error: schema };
  return { result: false, error: schema };
};

export {
  // validation,
  persianName,
  englishName,
  number,
  userName,
  password,
  email,
  phone,
  code,
  url,
  age,
  validateForm,
};
